module.exports = __webpack_public_path__ + "static/media/helvetia_logo_de.c6daf730.svg";